export const defaultData = {
    settings: { dark: true, version: 0.2 },
    stats: {
        1: {
            category: "Character Stats",
            title: "Intelligence",
            description:
                "Measures deductive reasoning, cognition, knowledge, memory, logic and rationality",
            minPoints: 0,
            allocatedPoints: 16,
            maxPoints: 20,
            imageUrl: "",
            color: "hsl(220,50%,50%)",
            numberColor: "white",
            id: 1,
        },
        2: {
            category: "Character Stats",
            title: "Dexterity",
            description: "Measures agility, balance, coordination and reflexes",
            minPoints: 0,
            allocatedPoints: 12,
            maxPoints: 20,
            imageUrl: "",
            color: "hsl(150,50%,50%)",
            numberColor: "white",
            id: 2,
        },
        3: {
            category: "Character Stats",
            title: "Strength",
            description: "Measures physical power and carrying capacity",
            minPoints: 0,
            allocatedPoints: 8,
            maxPoints: 20,
            imageUrl: "",
            color: "hsl(0,50%,50%)",
            numberColor: "white",
            id: 3,
        },
        4: {
            category: "Click to Edit Category",
            title: "Click to Edit Stat",
            description: "Click to Edit Description",
            minPoints: 0,
            allocatedPoints: 0,
            maxPoints: 99,
            imageUrl: "",
            color: "hsl(255,50%,50%)",
            numberColor: "hsl(0,100%,100%)",
            id: 4,
        },
    },
};
